<button type="button" class="btn btn-counter" [disabled]="disabled" [matMenuTriggerFor]="singleSelectMenu">
  {{ idea.votes }}
</button>

<mat-menu #singleSelectMenu="matMenu">
  <ng-template matMenuContent="">
    <div
      class="mat-mdc-menu-item no-hover cursor-auto"
      *ngFor="let user of users$ | async | slice: 0 : 1000; trackBy: identify"
    >
      <span class="d-inline-flex align-items-center w-100">
        <craft-user-icon class="d-flex shrink-0 mr-8" [user]="user"></craft-user-icon>
        <span class="ellipsis user-name mr-4">{{ user | fullName }}</span>
        <span class="ellipsis company-name" *ngIf="user?.userType === 'company'">
          {{ $any(user).companyId | craftCompanyName | async }}</span
        >
      </span>
    </div>
  </ng-template>
</mat-menu>
